import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-role',
  templateUrl: './modify-role.component.html',
  styleUrls: ['./modify-role.component.css']
})
export class ModifyRoleComponent implements OnInit {

  roles: any = [];
  editForm: any | FormGroup;
  roleId: any = "";
  cid:any;
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  editButton = true;
  editSubmit = false;
  privileges:any = [];
  singleRoleData:any;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllRoles()
    this.editForm = this.fb.group({
      roleName :['']
    })
    this.getAllPrivileges()
  }

  onTableDataChange(event: any) {
    this.page = event;
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
  }
  
  getAllRoles(){
    this.generic_service.getAllRoles().subscribe(
      (response:any)=>{
        console.log(response)
        this.roles = response.response
      }
    )
  }


  // updateRole(){
  //   let body = {
  //     "version": 0,
  //     "isActive": true,
  //     "description": "string",
  //     "roleId": this.roleId,
  //     "roleName": String(this.editForm.get('roleName').value),
  //     "rolePrevilagesIds": [
  //       0
  //     ],
  //     "cid": this.cid
  //   }
  //   console.log(body)
  //   this.generic_service.updateRole(body).subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.getAllRoles()
  //       this.toastr.success("Successfully Updated");
  //       this.cancelModel()
  //       this.editForm.reset()
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }
  
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllPrivileges(){
    this.generic_service.getAllPrivileges().subscribe(
      (response:any)=>{
        this.privileges = response.response;
        for(let i=0;this.privileges.length > i; i++){
          this.privileges[i].isChecked = false;
          for(let j=0;this.privileges[i].screenPrivilegeList.length > j; j++){
            this.privileges[i].screenPrivilegeList[j].isChecked = false;
          }
        }
        console.log(response)
        console.log(this.privileges)
      }
    )
  }

  isChecked(event:any,i:any){
    console.log(event)
    console.log(i)
    this.privileges[i].isChecked = event.target.checked;
    if(this.privileges[i].isChecked == true){
      for(var j=0;j<this.privileges[i].screenPrivilegeList.length;j++){
        this.privileges[i].screenPrivilegeList[j].isChecked = true;
      }
    }else{
      for(var j=0;j<this.privileges[i].screenPrivilegeList.length;j++){
        this.privileges[i].screenPrivilegeList[j].isChecked = false;
      }
    }
    console.log(this.privileges)
  }

  screenCheck(event: any,i: any,j: any){
    this.privileges[i].screenPrivilegeList[j].isChecked = event.target.checked;
    console.log(this.privileges)
    let privilege = false;
    if(event.target.checked == false){
      for(var k=0;k<this.privileges[i].screenPrivilegeList.length;k++){
        if(this.privileges[i].screenPrivilegeList[k].isChecked == true){
          privilege = true;
        }
      }
      if(privilege == false){
        this.privileges[i].isChecked = false;
      }
    }else{
      this.privileges[i].isChecked = true;
    }
  }

  getRoleById(id:any){
    this.roleId = id
    for(let i=0;this.privileges.length > i; i++){
      this.privileges[i].isChecked = false;
      for(let j=0;this.privileges[i].screenPrivilegeList.length > j; j++){
        this.privileges[i].screenPrivilegeList[j].isChecked = false;
      }
    }
    console.log(this.privileges)
    this.generic_service.getRoleById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleRoleData = response.response;
        this.editForm.patchValue({
          roleName: response.response.roleName
        });
        for(var i=0; i<response.response.screenGroupList.length; i++){
          for(var j=0; j<this.privileges.length; j++){
            if(this.privileges[j].groupName == response.response.screenGroupList[i].groupName){
              this.privileges[j].isChecked = true;
              for(var k=0; k<response.response.screenGroupList[i].screenPrivilegeList.length; k++){
                for(var l=0; l<this.privileges[j].screenPrivilegeList.length; l++){
                  if(response.response.screenGroupList[i].screenPrivilegeList[k].description == this.privileges[j].screenPrivilegeList[l].description){
                    this.privileges[j].screenPrivilegeList[l].isChecked = true;
                  }
                }
              }
            }
          }
        }
        console.log(this.privileges)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  updateRole(){
    this.editSubmit = true;
    if(!this.editForm.valid){
      console.log('invalid')
      this.toastr.error('role name required')

      return
    }else{
      let atleastOneRoleSelected = false
      for(var i=0; i<this.privileges.length;i++){
        if(this.privileges[i].isChecked){
          atleastOneRoleSelected = true;
        }
      }
      if(!atleastOneRoleSelected){
        this.toastr.error('select minimum one role')
        return
      }
    }
    this.editButton = false;
    console.log(this.privileges)
    let screenGroupList:any = []
    for(var i=0; i<this.privileges.length;i++){
      if(this.privileges[i].isChecked){

        let arr:any = {
          "version": Number(this.privileges[i].version),
          "isActive": Boolean(this.privileges[i].isActive),
          "description": String(this.privileges[i].description),
          "seqNo": Number(this.privileges[i].seqNo),
          "groupName": String(this.privileges[i].groupName),
          "screenPrivilegeList": [],
          "cid": Number(this.privileges[i].cid),
        }

        for(var j=0; j<this.privileges[i].screenPrivilegeList.length;j++){
          if(this.privileges[i].screenPrivilegeList[j].isChecked){
            let screenPrivilegeList = {
              "seqNo": Number(this.privileges[i].screenPrivilegeList[j].seqNo),
              "name": String(this.privileges[i].screenPrivilegeList[j].name),
              "description": String(this.privileges[i].screenPrivilegeList[j].description),
              "screenPrivilegeScopeList": this.privileges[i].screenPrivilegeList[j].screenPrivilegeScopeList
            }
            arr.screenPrivilegeList.push(screenPrivilegeList)
          }
        }

        screenGroupList.push(arr)
      }

    }

    let body = {
      "version": Number(this.singleRoleData.version),
      "isActive": Boolean(this.singleRoleData.isActive),
      "description": String(this.singleRoleData.description),
      "roleId": Number(this.singleRoleData.roleId),
      "roleName": String(this.editForm.get('roleName').value),
      "screenGroupList": screenGroupList,
      "cid": Number(this.singleRoleData.cid),
    }
     console.log(body)
     this.generic_service.updateRole(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllRoles()
        this.toastr.success(res.message);
        this.cancelModel()
        this.editForm.reset()
        this.getAllPrivileges()
        this.editButton = true;
        this.editSubmit = false;
      },
      (error:any)=>{
         console.log(error)
         this.editButton = true
      }
    )
  }
  
  editRoleClose(){
    this.editForm.reset()
  }
  
}
